<script lang="ts" module>
  export const accountModal = new ModalQueryState('account');
  export const signedOut = $state({ current: false });
</script>

<script lang="ts">
  import { page } from '$app/state';
  import Account from '~icons/mdi/account';
  import Reset from '~icons/mdi/refresh';
  import Close from '~icons/mdi/close';
  import ActionButton from '~/components/ActionButton.svelte';
  import Modal from '~/components/Modal.svelte';
  import { signoutMutation } from './mutations.svelte';
  import { ModalQueryState } from '~/lib/nav.svelte';
  import ManageSubscription from './ManageSubscription.svelte';
  import { isPremium } from '~/lib/queries.svelte';
  import PaymentTable from './PaymentTable.svelte';
  import DeviceTable from './DeviceTable.svelte';
  import Premium from '~/icons/Premium.svelte';
  import LogOutIcon from '~icons/feather/log-out';

  const premium = isPremium();

  const signout = signoutMutation();

  const handleClose = () => {
    accountModal.pop(true);
  };

  // TODO should reset be its own page?
  // const handleReset = async () => {
  //   pushState('/reset');
  // }

  const handleSignOut = async () => {
    await signout.mutateAsync();
    signedOut.current = true;
    handleClose();
  };
</script>

<Modal index={5} open={accountModal.open} onClose={handleClose}>
  {#snippet title()}
    <Account />Account
  {/snippet}
  {#snippet content()}
    <div class="content">
      <div class="input-container">
        <label for="email">email</label>
        <input id="email" disabled value={page.data.user?.email} />
      </div>
      {#if premium.data}
        <PaymentTable />
        <ManageSubscription />
        <h4>Linked Devices</h4>
        <DeviceTable />
      {:else}
        <div class="premium">
          <ActionButton class="large" href="?premium=t" outlink={false}>
            <Premium />Get Premium
          </ActionButton>
        </div>
      {/if}
    </div>
  {/snippet}
  {#snippet controls()}
    <div class="controls">
      <ActionButton class="large" href="/reset" outlink={false}>
        <Reset />
        Change Password
      </ActionButton>
      <ActionButton
        class="large"
        onClick={handleSignOut}
        disabled={!(signout.isIdle || signout.isSuccess) || !page.data.user}
      >
        <LogOutIcon />
        {#if signout.isPending}
          logging out...
        {:else if signout.isSuccess && !page.data.user}
          logged out
        {:else}
          log out
        {/if}
      </ActionButton>
      <ActionButton class="large" onClick={handleClose}>
        <Close />
        Close
      </ActionButton>
    </div>
  {/snippet}
</Modal>

<style lang="scss">
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 24em;
  }
  .input-container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  #email {
    color: black;
  }

  .premium {
    padding: 1rem 0;
  }
  .controls {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0.25em;
    :global(.action svg) {
      width: 20px;
      height: 20px;
    }
  }
</style>
